import { render, staticRenderFns } from "./quickorderResumeListadoBtnCotizar.vue?vue&type=template&id=c951bfcc"
import script from "./quickorderResumeListadoBtnCotizar.vue?vue&type=script&lang=js"
export * from "./quickorderResumeListadoBtnCotizar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports